import InputField from 'components/InputField/InputField.component';
import { Input, LabelInput } from 'style/styleInput.style';
import styled from 'styled-components';

export const ContainerOtp = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const InputOtp = styled(Input)`
  border-bottom: 2px solid #d9d9d9;
  border-radius: 0px;
  width: 68px;
  border-width: 0 0 2px 0;
  margin-right: 16px;
  text-align: center;
  padding: 0;
`;

export const FlexOtp = styled.div<{ isFormErrorPresent?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;

  & > :last-child {
    margin: 0;
  }

  ${({ isFormErrorPresent }) =>
    isFormErrorPresent
      ? `& > ${InputOtp} { border-bottom: 2px solid #E32219;}`
      : ''}

  ${({ isFormErrorPresent }) =>
    isFormErrorPresent ? `${Input} { border: 1px solid  #E32219; }` : ''}

  ${({ isFormErrorPresent }) =>
    isFormErrorPresent
      ? `${LabelInput}, ${LabelInput}:focus { color:  #E32219 !important; }`
      : ''}
`;

export const OtpInputField = styled(InputField)`
  max-height: 44px;
  width: 100%;
`;
